var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 429 599",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.308 0.654175V31.6542L397.108 169.654V522.554L428.708 538.754V154.754L127.308 0.654175Z",
    fill: "#6C73F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9085 30.2542V61.2542L333.708 199.254V552.254L365.409 568.454V184.454L63.9085 30.2542Z",
    fill: "#6C73F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.008 598.054L0.508484 443.954V59.9542L302.008 214.054V598.054Z",
    fill: "#6C73F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCase);
export default __webpack_public_path__ + "static/media/MyCase.a2a4fe32f0dfd8b1f3ebfa975ffa7a78.svg";
export { ForwardRef as ReactComponent };